// material-table leaves its pagination buttons without aria-labels; their
// tooltips sit on a wrapping <span>, so screen readers announce them as
// unlabeled buttons (WCAG 4.1.2). Pass this as every table's `localization`.
export const tableLocalization = {
  pagination: {
    firstAriaLabel: 'First page',
    previousAriaLabel: 'Previous page',
    nextAriaLabel: 'Next page',
    lastAriaLabel: 'Last page',
  },
};
